import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import { installAuthInterceptors } from './utils/auth';

// Every component uses the bare axios singleton, so installing interceptors on
// it here attaches the admin JWT to all API calls and handles expired sessions.
installAuthInterceptors(axios);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

